import client from './client';
import { unwrapData } from './response';

export const listPosts = async (params = {}) => {
  const response = await client.get('/articles/admin', { params });
  return unwrapData(response);
};

export const createPost = async (payload) => {
  const response = await client.post('/articles/admin', payload);
  return unwrapData(response, null);
};

export const updatePost = async (id, payload) => {
  const response = await client.put(`/articles/admin/${id}`, payload);
  return unwrapData(response, null);
};

export const deletePost = async (id) => {
  const response = await client.delete(`/articles/admin/${id}`);
  return unwrapData(response, null);
};

export const uploadPostImage = async (file) => {
  const formData = new FormData();
  formData.append('photo', file);

  const response = await client.post('/articles/admin/images', formData);
  return unwrapData(response, null);
};
